<template>
    <div
        class="smokeBg fixed z-10 flex h-full w-full flex-col bg-black text-center"
        :style="{ paddingTop: `${safezoneTop}px`, paddingBottom: `${safezoneBottom}px` }"
    >
        <div
            class="absolute z-10 flex items-center gap-2 p-4"
            @click="$bridge.emit('gameon.close', { reason: 'user_action' })"
        >
            <svg
                width="9"
                height="14"
                viewBox="0 0 9 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.12109 1.41406L2.82812 6.70703L8.12109 12L6.70703 13.4141L0 6.70703L6.70703 0L8.12109 1.41406Z"
                    fill="white"
                />
            </svg>
            {{ $t('maintenance.go_back') }}
        </div>
        <div class="absolute flex h-full w-full flex-col gap-2 p-16 backdrop-blur-xs">
            <h1 class="font-title text-2xl font-bold uppercase">{{ $t('maintenance.coming_soon') }}</h1>
            <p class="text-sm">{{ $t('maintenance.subtitle') }}</p>
            <img src="@/assets/images/logo.svg" class="m-auto w-full max-w-72" />
        </div>
        <div class="comingSoonBg h-full w-full justify-center"></div>
    </div>
</template>

<script>
export default {
    name: 'ComingSoonView',
    computed: {
        safezoneTop() {
            return document.safeZone?.top || 0
        },
        safezoneBottom() {
            return document.safeZone?.bottom || 0
        },
    },
}
</script>

<style lang="scss">
.comingSoonBg {
    background: url('@/assets/images/mockups.webp') no-repeat center 60%;
    background-size: auto 60%;
}

.smokeBg {
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -2;
        background: url('@/assets/images/smoke.webp') no-repeat center center;
        background-size: cover;
        opacity: 0.3;
    }
}
</style>
